export const ClinicAddressAndHoursFooter = {
  displayMode: 'email',
  category: 'Footer',
  tags: ['Service', 'Reminder', 'Hours', 'Clinic', 'Address', 'Logo'],
  data: {
    cells: [16.2, 24.23, 29.64, 29.93],
    columns: [
      {
        contents: [
          {
            type: 'image',
            values: {
              containerPadding: '10px',
              anchor: '',
              src: {
                url: '[[{clinic_logo_url}]]',
                width: 800,
                height: 200,
                source: 'user',
                maxWidth: '100%',
                autoWidth: false,
              },
              textAlign: 'center',
              altText: '',
              action: {
                name: 'web',
                values: {
                  href: '',
                  target: '_blank',
                },
              },
              hideDesktop: false,
              displayCondition: null,
              _meta: {
                htmlClassNames: 'u_content_image',
              },
              selectable: true,
              draggable: true,
              duplicatable: true,
              deletable: true,
              hideable: true,
            },
          },
        ],
        values: {
          _meta: {
            htmlClassNames: 'u_column',
          },
          border: {
            borderTopStyle: 'solid',
            borderTopWidth: '0px',
            borderLeftStyle: 'solid',
            borderLeftWidth: '0px',
            borderRightStyle: 'solid',
            borderRightWidth: '0px',
            borderBottomStyle: 'solid',
            borderBottomWidth: '0px',
          },
          padding: '0px',
          borderRadius: '0px',
          backgroundColor: '',
        },
      },
      {
        contents: [
          {
            type: 'text',
            values: {
              containerPadding: '10px',
              anchor: '',
              textAlign: 'left',
              lineHeight: '140%',
              linkStyle: {
                inherit: true,
                linkColor: '#0000ee',
                linkHoverColor: '#0000ee',
                linkUnderline: true,
                linkHoverUnderline: true,
              },
              hideDesktop: false,
              displayCondition: null,
              _meta: {
                htmlClassNames: 'u_content_text',
              },
              selectable: true,
              draggable: true,
              duplicatable: true,
              deletable: true,
              hideable: true,
              text: '<p style="font-size: 14px; line-height: 140%;"><strong>{{clinic.name}}</strong></p>\n<p style="font-size: 14px; line-height: 140%;">{{clinic.addressLine1}}</p>\n<p style="font-size: 14px; line-height: 140%;">{{clinic.addressLine2}}</p>\n<p style="font-size: 14px; line-height: 140%;">{{clinic.city}}, {{clinic.state}} {{clinic.postalCode}}</p>',
            },
          },
        ],
        values: {
          _meta: {
            htmlClassNames: 'u_column',
          },
          border: {
            borderTopStyle: 'solid',
            borderTopWidth: '0px',
            borderLeftStyle: 'solid',
            borderLeftWidth: '0px',
            borderRightStyle: 'solid',
            borderRightWidth: '0px',
            borderBottomStyle: 'solid',
            borderBottomWidth: '0px',
          },
          padding: '0px',
          borderRadius: '0px',
          backgroundColor: '',
        },
      },
      {
        contents: [
          {
            type: 'text',
            values: {
              containerPadding: '10px',
              anchor: '',
              textAlign: 'left',
              lineHeight: '140%',
              linkStyle: {
                inherit: true,
                linkColor: '#0000ee',
                linkHoverColor: '#0000ee',
                linkUnderline: true,
                linkHoverUnderline: true,
              },
              hideDesktop: false,
              displayCondition: null,
              _meta: {
                htmlClassNames: 'u_content_text',
              },
              selectable: true,
              draggable: true,
              duplicatable: true,
              deletable: true,
              hideable: true,
              text: '<p style="font-size: 14px; line-height: 140%;"><strong>Hours:</strong></p>\n<p style="font-size: 14px; line-height: 140%;">Mon: {{hours.monday}}</p>\n<p style="font-size: 14px; line-height: 140%;">Tues: {{hours.tuesday}}</p>\n<p style="font-size: 14px; line-height: 140%;">Wed: {{hours.wednesday}}</p>\n<p style="font-size: 14px; line-height: 140%;">Thurs: {{hours.thursday}}</p>',
              _override: {
                mobile: {
                  containerPadding: '10px 10px 0px',
                },
              },
            },
          },
        ],
        values: {
          _meta: {
            htmlClassNames: 'u_column',
          },
          border: {
            borderTopStyle: 'solid',
            borderTopWidth: '0px',
            borderLeftStyle: 'solid',
            borderLeftWidth: '0px',
            borderRightStyle: 'solid',
            borderRightWidth: '0px',
            borderBottomStyle: 'solid',
            borderBottomWidth: '0px',
          },
          padding: '0px',
          borderRadius: '0px',
          backgroundColor: '',
        },
      },
      {
        contents: [
          {
            type: 'text',
            values: {
              containerPadding: '10px',
              anchor: '',
              textAlign: 'left',
              lineHeight: '140%',
              linkStyle: {
                inherit: true,
                linkColor: '#0000ee',
                linkHoverColor: '#0000ee',
                linkUnderline: true,
                linkHoverUnderline: true,
              },
              hideDesktop: false,
              displayCondition: null,
              _meta: {
                htmlClassNames: 'u_content_text',
              },
              selectable: true,
              draggable: true,
              duplicatable: true,
              deletable: true,
              hideable: true,
              text: '<p style="font-size: 14px; line-height: 140%;">Fri: {{hours.friday}}</p>\n<p style="font-size: 14px; line-height: 140%;">Sat: {{hours.saturday}}</p>\n<p style="font-size: 14px; line-height: 140%;">Sun: {{hours.sunday}}</p>',
              _override: {
                mobile: {
                  containerPadding: '0px 10px 10px',
                },
              },
            },
          },
        ],
        values: {
          _meta: {
            htmlClassNames: 'u_column',
          },
          border: {
            borderTopStyle: 'solid',
            borderTopWidth: '0px',
            borderLeftStyle: 'solid',
            borderLeftWidth: '0px',
            borderRightStyle: 'solid',
            borderRightWidth: '0px',
            borderBottomStyle: 'solid',
            borderBottomWidth: '0px',
          },
          padding: '0px',
          borderRadius: '0px',
          backgroundColor: '',
        },
      },
    ],
    values: {
      displayCondition: null,
      columns: false,
      backgroundColor: '',
      columnsBackgroundColor: '#f3f4fa',
      backgroundImage: {
        url: '',
        fullWidth: true,
        repeat: 'no-repeat',
        size: 'custom',
        position: 'top-center',
        customPosition: ['50%', '0%'],
      },
      padding: '4px 0px',
      anchor: '',
      hideDesktop: false,
      _meta: {
        htmlClassNames: 'u_row',
      },
      selectable: true,
      draggable: true,
      duplicatable: true,
      deletable: true,
      hideable: true,
    },
    schemaVersion: 11,
  },
  custom: true,
};
